import React from 'react'

interface OrderIconI {
    order_by: string
}
const OrderIcon: React.FC<OrderIconI> = ({ order_by }) => {

    return (
        <>
            {
                order_by === 'asc' ? <i
                    className="zmdi zmdi-sort-asc ml"></i> :
                    <i className="zmdi zmdi-sort-desc ml"></i>
            }
        </>
    )
}

export default React.memo(OrderIcon)
